// extracted by mini-css-extract-plugin
module.exports = {"root":"LabNotesContainer_root__2jtxY","formTitle":"LabNotesContainer_formTitle__2knTy","main":"LabNotesContainer_main__1flZ3","tableWrap":"LabNotesContainer_tableWrap__2wYQK"};